<div class="page-card">
    <div class="page-card-header">
        <h1><ng-content select="[textHeader]"></ng-content></h1>
        <ng-content select="[middleSectionHeader]"></ng-content>
        <div class="action-buttons-container">
            <div class="actions">
                <ng-content select="[actionsHeader]"></ng-content>
            </div>
            @if (isClosable()) {
                <btn-icon
                    [id]="'page-card-exit-button'"
                    [icon]="'fa-solid fa-xmark-large'"
                    [text]="true"
                    [rounded]="true"
                    [severity]="'secondary'"
                    [class]="'page-card-exit-button'"
                    (onClick)="onCloseClick()">
                </btn-icon>
            }
        </div>
    </div>
    <div class="page-card-body">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
